import { render } from "./IconScanDefaultMini.vue?vue&type=template&id=41645e51"
import script from "./IconScanDefaultMini.vue?vue&type=script&lang=ts"
export * from "./IconScanDefaultMini.vue?vue&type=script&lang=ts"
script.render = render

export default script